import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="agb-page">
      <div className="agb-container">
        <Button 
          onClick={() => navigate('/')} 
          className="back-button"
          variant="outline"
        >
          <ArrowLeft className="mr-2" />
          Zurück zur Startseite
        </Button>
        
        <h1 className="agb-title">Datenschutzerklärung</h1>
        
        <div className="agb-content">
          <div className="agb-header">
            <p className="agb-company">Informationen zur Verarbeitung personenbezogener Daten</p>
            <p className="agb-details">
              Sportfreund Cowboy e.U. • Inhaber: Mag. Christian Mannert • Wiener Straße 21, 7100 Neusiedl am See<br />
              Firmenbuchnummer: FN 677254 m • Landesgericht Eisenstadt • E-Mail: sportfreundcowboy@gmail.com
            </p>
          </div>

          <section className="agb-section">
            <p>Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2021, DSG). In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website und unserer Dienstleistungen.</p>
          </section>

          <section className="agb-section">
            <h2>1. Verantwortlicher für die Datenverarbeitung</h2>
            <p>
              <strong>Sportfreund Cowboy e.U.</strong><br />
              Inhaber: Mag. Christian Mannert<br />
              Wiener Straße 21, 7100 Neusiedl am See<br />
              Firmenbuchnummer: FN 677254 m (Landesgericht Eisenstadt)<br />
              E-Mail: sportfreundcowboy@gmail.com
            </p>
          </section>

          <section className="agb-section">
            <h2>2. Datenverarbeitung bei Buchung & Durchführung der Touren</h2>
            <p>Wenn Sie eine geführte Radtour oder ein sonstiges Erlebnis bei uns buchen (direkt oder über Kooperationspartner wie ÖBB Rail Tours oder Hotelpartner), verarbeiten wir folgende Daten:</p>
            <ul>
              <li><strong>Stammdaten:</strong> Name, Adresse, Kontaktdaten (Telefonnummer, E-Mail-Adresse).</li>
              <li><strong>Buchungsdaten:</strong> Datum der Tour, Anzahl der Teilnehmer, genutztes Equipment, eventuelle gesundheitliche Hinweise (sofern für die Sicherheit auf der Tour relevant und freiwillig angegeben).</li>
            </ul>
            <p><strong>Zweck & Rechtsgrundlage:</strong> Die Verarbeitung dieser Daten ist für die Vertragserfüllung bzw. zur Durchführung vorvertraglicher Maßnahmen erforderlich (Art. 6 Abs. 1 lit. b DSGVO). Ohne diese Daten können wir den Vertrag nicht abschließen oder durchführen.</p>
          </section>

          <section className="agb-section">
            <h2>3. Bild-, Video- und Drohnenaufnahmen (Erinnerungsvideos)</h2>
            <p>Ein wesentlicher Teil des Erlebnisses bei Sportfreund Cowboy e.U. ist die Erstellung von visuellem Erinnerungsmaterial (Fotos, Videos und Luftaufnahmen mittels Drohne).</p>
            <ol>
              <li><strong>Erstellung & Bereitstellung (Vertragserfüllung):</strong> Wir nehmen während der Tour Fotos und Videos von Ihnen und der Gruppe auf. Diese Aufnahmen werden verarbeitet, um das vereinbarte Erinnerungsvideo zu erstellen und es Ihnen (und den anderen Teilnehmern Ihrer Gruppe) zur Verfügung zu stellen. <em>Rechtsgrundlage:</em> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Ihre ausdrückliche Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).</li>
              <li><strong>Nutzung zu Marketingzwecken:</strong> Wir nutzen ausgewählte Aufnahmen für unsere eigene Werbung (Website, Social Media, Flyer). <em>Rechtsgrundlage:</em> Ihre ausdrückliche Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) bzw. unser berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO), unsere Dienstleistungen zu präsentieren.</li>
            </ol>
            <p><strong>Ihr Recht auf Widerspruch:</strong><br />
            Sie können der Aufnahme Ihrer Person vor Beginn der Tour oder der späteren Verwendung für Marketingzwecke jederzeit formlos widersprechen (z. B. per E-Mail an sportfreundcowboy@gmail.com).</p>
          </section>

          <section className="agb-section">
            <h2>4. Datenverarbeitung auf unserer Website</h2>
            <p><strong>Kontakt mit uns:</strong> Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. <em>Rechtsgrundlage:</em> Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).</p>
            <p><strong>Server-Log-Files:</strong> Der Provider der Website erhebt und speichert automatisch Informationen in sogenannten Server-Log-Files, die Ihr Browser automatisch an uns übermittelt (z.B. IP-Adresse, Browsertyp, Datum/Uhrzeit der Anfrage). Diese Daten sind nicht bestimmten Personen zuzuordnen und dienen rein der Sicherheit und technischen Optimierung der Website. <em>Rechtsgrundlage:</em> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der fehlerfreien Funktion der Website).</p>
          </section>

          <section className="agb-section">
            <h2>5. Empfänger der Daten (Datenweitergabe)</h2>
            <p>Ihre Daten werden von uns vertraulich behandelt. Eine Weitergabe an Dritte erfolgt nur, wenn dies zur Vertragserfüllung notwendig ist oder gesetzliche Pflichten dies vorschreiben:</p>
            <ul>
              <li><strong>Innerhalb der Tour-Gruppe:</strong> Das fertige Gruppen-Erinnerungsvideo wird den Teilnehmern derselben Tour zur Verfügung gestellt.</li>
              <li><strong>Kooperationspartner:</strong> Bei Buchungen über Partner (z. B. ÖBB Rail Tours) tauschen wir die zur Abwicklung notwendigen Buchungsdaten aus.</li>
              <li><strong>Auftragsverarbeiter:</strong> IT-Dienstleister, Hosting-Anbieter unserer Website, Cloud-Anbieter für den Videoversand. Diese sind vertraglich zur strengen Einhaltung der DSGVO verpflichtet.</li>
            </ul>
          </section>

          <section className="agb-section">
            <h2>6. Speicherdauer</h2>
            <ol>
              <li><strong>Vertragsdaten:</strong> Wir speichern Ihre Daten für die Dauer der Vertragserfüllung sowie darüber hinaus gemäß den gesetzlichen Aufbewahrungs- und Verjährungsfristen (in Österreich in der Regel 7 Jahre gemäß § 132 Abs. 1 BAO für steuerrechtlich relevante Belege).</li>
              <li><strong>Bild- und Videomaterial:</strong> Bild- und Videomaterial, das für das Erinnerungsvideo erstellt wurde, wird nach der erfolgreichen Bereitstellung an Sie sicher archiviert bzw. gelöscht, sofern keine Einwilligung für eine längere Nutzung zu Marketingzwecken vorliegt.</li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>7. Ihre Rechte</h2>
            <p>Ihnen stehen bezüglich Ihrer bei uns gespeicherten Daten grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit, Widerruf und Widerspruch zu.</p>
            <p>Wenn Sie der Meinung sind, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich direkt bei uns (sportfreundcowboy@gmail.com) oder bei der zuständigen Aufsichtsbehörde beschweren. In Österreich ist dies die:</p>
            <p>
              <strong>Österreichische Datenschutzbehörde</strong><br />
              Barichgasse 40-42, 1030 Wien<br />
              E-Mail: dsb@dsb.gv.at
            </p>
          </section>

          <div className="agb-download-section">
            <h3>Datenschutzerklärung als PDF herunterladen</h3>
            <p>Laden Sie sich die vollständige Datenschutzerklärung als PDF-Dokument herunter:</p>
            <a 
              href="/assets/Datenschutzerklaerung_Sportfreund_Cowboy.pdf" 
              download="Datenschutzerklaerung_Sportfreund_Cowboy.pdf"
              className="agb-download-button"
            >
              <Download className="mr-2" />
              Datenschutzerklärung herunterladen (PDF)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
